import { Link } from 'react-router';
import { ArrowLeft } from 'lucide-react';

export function NotFoundPage() {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-6 text-center">
      <p className="text-brand-500 text-sm font-semibold tracking-widest uppercase">
        404 error
      </p>
      <h1 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl dark:text-white">
        Page not found
      </h1>
      <p className="max-w-md text-base text-gray-500 dark:text-gray-400">
        We couldn&apos;t find the page you were looking for. It may have moved
        or been deleted.
      </p>
      <Link
        to="/"
        className="bg-brand-500 hover:bg-brand-600 focus-visible:outline-brand-500 inline-flex items-center gap-2 rounded-md px-4 py-2.5 text-sm font-medium text-white shadow-sm transition focus-visible:outline-2 focus-visible:outline-offset-2"
      >
        <ArrowLeft className="h-4 w-4" aria-hidden="true" />
        Back to dashboard
      </Link>
    </div>
  );
}
